<template>
  <div class="location-container">
    <div class="location-map">
      <l-map v-if="viewport" :zoom="viewport.zoom" :center="viewport.center">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker v-for="(marker, index) in markers" :lat-lng="marker.position" :icon="marker.icon" :title="marker.title" :key="index"  @click="clicked(marker.location)"></l-marker>
      </l-map>
    </div>
    <div class="location-list">
      <div
        v-for="(location, index) in locations"
        class="location-description link"
        @click="clicked(location)"
        :class="[{'current': $store.state.location === location}, 'location-' + location.slug]"
        :key="index"
      >
        <div class="title">{{location.name}}</div>
        <div class="address pre">{{ location.address }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import Leaflet from 'leaflet'

export default {
  name: 'LocationSelect',
  components: { LMap, LTileLayer, LMarker },
  data() {
    return {
      zoom: 13,
      url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
      // url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      // url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      userPos: null,
    }
  },
  mounted() {
    // if (navigator.geolocation) { // TODO: only if no idea
    //   var data = this
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     // console.log(position)
    //     data.userPos = position
    //   })
    // }
  },
  methods: {
    deg2rad(deg) {
      return deg * (Math.PI / 180)
    },
    distance(lat1, lon1, lat2, lon2) {
      if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) return null
      var R = 6371.0 // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1)
      var dLon = this.deg2rad(lon2 - lon1)
      var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c // Distance in km
    },
    metresPerPixel(map) {
      if (!map) return null
      return 40075016.686 * Math.abs(Math.cos(map.getCenter().lat * 180 / Math.PI)) / Math.pow(2, map.getZoom() + 8)
    },
    clicked(location) {
        window.location.href = `https://${location.slug}.${this.domain}${window.location.pathname}`
    },
  },
  asyncComputed: {
    ...mapState(['domain', 'location', 'locations']),
    markers() {
      var m = []
      if (this.locations) {
        var currentLocation = this.location
        this.locations.forEach(function (location) {
          var iconUrl = '/yamyam-marker.svg'
          if (location === currentLocation) iconUrl = '/yamyam-marker-active.svg'
          m.push({
            title: location.name + ' ' + location.address.city,
            position: Leaflet.latLng(location.coords.lat, location.coords.lng),
            location: location,
            icon: Leaflet.icon({
              iconUrl: iconUrl,
              shadowUrl: '/marker-shadow.svg',
              iconSize: 50,
              shadowSize: 70,
              iconAnchor: [25, 50],
              shadowAnchor: [20, 50],
              popupAnchor: [-3, -76],
            }),
          })
        })
      }

      if (this.userPos) {
        m.push({
          position: Leaflet.latLng(this.userPos.coords.latitude, this.userPos.coords.longitude),
          icon: Leaflet.icon({
            iconUrl: '/map-position.svg',
            iconSize: [30, 60],
            iconAnchor: [15, 60],
            popupAnchor: [-3, -76],
          }),
        })
      }

      return m
    },
    viewport() {
      if (!this.markers || !Array.isArray(this.markers) || this.markers.length === 0) return null
      var minLat = this.markers[0].position.lat
      var maxLat = this.markers[0].position.lat
      var minLng = this.markers[0].position.lng
      var maxLng = this.markers[0].position.lng
      this.markers.forEach(function (marker) {
        if (marker.position.lat < minLat) minLat = marker.position.lat
        if (marker.position.lat > maxLat) maxLat = marker.position.lat
        if (marker.position.lng < minLng) minLng = marker.position.lng
        if (marker.position.lng > maxLng) maxLng = marker.position.lng
      })
      var latDist = maxLat - minLat
      var lngDist = maxLng - minLng
        // console.log(Leaflet.latLng(minLat + latDist / 2, minLng + lngDist / 2))
      return {
        center: Leaflet.latLng(minLat + latDist / 2, minLng + lngDist / 2),
        zoom: 7, // TODO: dynamic zoom
      }
    },
  },
}
</script>

<style lang="scss">
@import "@/style/settings.scss";

.leaflet-control {
  text-shadow: none;
}
.leaflet-touch .leaflet-bar a {
  height: 26px !important;
}
.leaflet-control-attribution {
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 100%) !important;
  color: $text-color;
  text-shadow: 1px 1px 2px #000;
  a {
    color: $text-color;
  }
}

.location-container {
  height: 100%;
  min-height: 350px;
  display: flex;
  flex-wrap: nowrap;

  @media (orientation: landscape) {
    flex-direction: row;
    > * {
      &:not(:last-child) {
        margin-right: $spacing;
      }
    }

    .location-list {
      flex-flow: column wrap;
      > * {
        &:not(:last-child) {
          margin-bottom: $spacing;
        }
      }
    }
  }

  @media (orientation: portrait) {
    flex-direction: column;
    > * {
      &:not(:last-child) {
        margin-bottom: $spacing;
      }
    }

    .location-list {
      flex-flow: row nowrap;
      > * {
        &:not(:last-child) {
          margin-right: $spacing;
        }
      }
    }
  }
  .location-map {
    height: 100%;
    min-height: 40vh;
    // max-height: 60vh;
    flex-grow: 1;
    .leaflet-container {
      min-height: inherit;
      width: 100%;
      height: 100%;
    }
  }
  .location-list {
    display:flex;
    min-height: 170px;

    .location-description {
      flex-grow: 1;
      padding: $spacing;
      text-align: left;
      border: 2px solid rgba($text-color,.2);
      background-color: rgba($background-color,.6);
      position:relative;

      @each $location in $locations {
        &.location-#{$location} {
          &:after {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: -1;
            content: "";
            background: url("/logo-#{$location}.svg");
            background-size: contain;
            background-position: right -30px top -20px;
            background-repeat: no-repeat;
            opacity: .9;
            filter: grayscale(20%);
          }
          &:hover {
            &:after {
              // opacity: 1;
              filter: grayscale(0%);
            }
          }
        }
      }

      &.current {
        border-color: rgba($highlight-color,.5);
      }

      .title {
        margin-bottom: $spacing * .5;
        font-size: 1.2em;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
</style>
